module.exports = __webpack_public_path__ + "img/Pista_1735.ad880cf0.png";